<script lang=ts>
      import { onMount } from "svelte"
      import { createPayloadContext, getPayloadContext } from "./ts/PayloadGlobals.svelte"


  let { children = null } = $props()


  onMount( () => {
    window._payloadContext = payloadContext
  })
  const payloadContext = getPayloadContext()
</script>


{@render children?.()}